export default {
	SET_PURCHASE_ORDERS: "SET_PURCHASE_ORDERS",
	CREATE_PURCHASE_ORDER: "CREATE_PURCHASE_ORDER",
	SET_LOADING: "SET_LOADING",
	SET_PAGE_INFO: "SET_PAGE_INFO",
	SET_FILTERS: "SET_FILTERS"
};
